import { useGetBackofficeCompanyQuery } from "modules/backoffice/hooks/companies/useGetBackofficeCompanyQuery"
import { HeaderButtons } from "modules/shared/components/Breadcrumbs/HeaderButtons"
import { Loading } from "modules/shared/components/Loading"
import { Route as BackofficeCompanyRoute } from "routes/_base/_auth/backoffice/organizations/$id/companies/$companyId"
import { BackofficeImpersonateOrganization } from "../organizations/BackofficeImpersonateOrganization"
import { BackofficeCompanySections } from "./BackofficeCompanySections"

export const BackofficeCompanyDetail = () => {
  const { id: organizationId, companyId } = BackofficeCompanyRoute.useParams()
  const { data: company, isPending } = useGetBackofficeCompanyQuery({ query: { id: companyId } })

  if (isPending)
    return (
      <div className="flex justify-center items-center h-40">
        <Loading />
      </div>
    )

  return (
    <>
      <HeaderButtons>
        <BackofficeImpersonateOrganization id={organizationId} />
      </HeaderButtons>
      <h2 className="text-2xl font-semibold">{company?.name}</h2>
      <BackofficeCompanySections organizationId={organizationId} companyId={companyId} />
    </>
  )
}
